import { ScanFace, UserPlus, Send } from "lucide-react";

const STEPS = [
    {
        icon: ScanFace,
        title: "Complete Digital KYC",
        time: "10 minutes",
        desc: "PAN, GSTIN, company docs — fully online, video KYC where required. No branch visits.",
    },
    {
        icon: UserPlus,
        title: "Add Beneficiary & Upload Documents",
        time: "Once per vendor",
        desc: "Save global beneficiaries with bank details, purpose codes and supporting invoices.",
    },
    {
        icon: Send,
        title: "Send or Receive Payments Globally",
        time: "<24 hrs",
        desc: "Initiate from dashboard or API. We handle FX, SWIFT, compliance, FIRA/FIRC end-to-end.",
    },
];

export default function HowItWorks() {
    return (
        <section className="bg-white py-24 md:py-32 px-4 md:px-8" data-testid="how-it-works-section">
            <div className="mx-auto max-w-7xl">
                <div className="max-w-2xl">
                    <span className="text-xs tracking-[0.25em] uppercase font-bold text-emerald-700">
                        How it works
                    </span>
                    <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-zinc-950">
                        From signup to your first global payment in under 24 hours.
                    </h2>
                </div>

                <div className="mt-12 relative">
                    {/* Connector line */}
                    <div
                        aria-hidden
                        className="hidden md:block absolute top-12 left-[8%] right-[8%] h-px bg-gradient-to-r from-emerald-300/0 via-emerald-400 to-emerald-300/0"
                    />
                    <div className="grid md:grid-cols-3 gap-6 md:gap-8 relative">
                        {STEPS.map((s, i) => (
                            <article
                                key={s.title}
                                data-testid={`how-it-works-step-${i + 1}`}
                                className="relative rounded-3xl border border-zinc-200 bg-white p-7 sm:p-8 hover:shadow-[0_20px_60px_-30px_rgba(6,78,59,0.4)] transition-shadow"
                            >
                                <div className="flex items-center justify-between">
                                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-600 text-white glow-emerald">
                                        <s.icon className="h-5 w-5" />
                                    </span>
                                    <span className="font-mono text-xs tracking-widest text-zinc-400">
                                        STEP {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="font-heading mt-6 text-xl sm:text-2xl font-bold tracking-tight text-zinc-950">
                                    {s.title}
                                </h3>
                                <div className="mt-1 text-xs font-bold tracking-widest uppercase text-emerald-700">
                                    {s.time}
                                </div>
                                <p className="mt-3 text-sm sm:text-base text-zinc-600 leading-relaxed">
                                    {s.desc}
                                </p>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
